import { goodsPage, timeList } from '@/api/seckill';
import { mapGetters } from 'vuex';
import { adList } from '@/api/website';
import CountDown from 'vue2-countdown';

export default {
	name: 'groupbuy',
	components: { CountDown },
	data: () => {
		return {
			loading: true,
			timeList: [], //รายการเวลา
			seckillId: null, //ช่วงเวลาที่เลือก
			seckillName: null, //ชื่อของบล็อกเวลาที่เลือก
			seckillIndex: null, //บล็อกเวลาถูกเลือกไว้index
			goodsList: [], //รายการผลิตภัณฑ์สําหรับช่วงเวลาที่เลือก
			index: null, //ขณะนี้ถูกตะครุบขึ้นindex
			siteId: 0,
			total: 0,
			currentPage: 1,
			pageSize: 10,
			loadingAd: true,
			adList: [],
			seckillTimeMachine: {
				currentTime: 0,
				startTime: 0,
				endTime: 0
			},
			seckillText: 'เหลือเพียงอันเดียวจนกว่าจะถึงจุดสิ้นสุด',
			thumbPosition: 0,
			// สามารถเคลื่อนย้ายได้หรือไม่
			moveThumbLeft: false,
			moveThumbRight: false,
			shouType: true,
			isNoClick: false,
			key: 0
		};
	},
	watch: {
		seckillId(newName, oldName) {
			if (newName && newName != oldName) {
				this.refresh();
			}
		},
		addonIsExit() {
			if (this.addonIsExit.seckill != 1) {
				this.$notify({
					message: 'ไม่ได้ติดตั้งปลั๊กอิน Lightning Deal',
					title: 'คำเตือน',type: 'warning',
					duration: 2000,
					onClose: () => {
						this.$route.push('/');
					}
				});
			}
		}
	},
	created() {
		if (this.addonIsExit && this.addonIsExit.seckill != 1) {
			this.$notify({
				message: 'ไม่ได้ติดตั้งปลั๊กอิน Lightning Deal',
				title: 'คำเตือน',type: 'warning',
				duration: 2000,
				onClose: () => {
					this.$route.push('/');
				}
			});
		} else {
			this.getAdList();
			this.getTimeList();
		}
	},
	computed: {
		isTrue() {
			let num = 0;
			if (this.timeList && this.timeList[this.index]) {
				num = this.timeList[this.index].isNow;
			}
			return num;
		},
		...mapGetters(['defaultGoodsImage', 'addonIsExit'])
	},
	methods: {
		/**
		 * คลิกช่วงเวลา
		 */
		handleSelected(i, item) {
			this.key = i;
			let text = this.timeList[i].name
			if (i < this.index) {
				this.$message.warning(text+ ' กิจกรรมจบลงแล้วโปรดรอกิจกรรมต่อไป')
			} else if (i > this.index) {
				this.shouType = false;
				this.seckillId = item.id;
				this.isNoClick = true;
				this.seckillName = item.name;
				// this.$message.warning(text+ 'ดีลสายฟ้ายังไม่เริ่ม')
				//this.getGoodsList();
				this.getTimeList();
			}else{
				this.seckillId = item.id;
				this.shouType = true;
				this.isNoClick = false;
				this.seckillName = item.name;
				//this.getGoodsList();
				this.getTimeList();
			}
		},
		/**
		 * คลิกลูกศรด้านหน้าและด้านหลัง
		 */
		changeThumbImg(tag) {
			let _div = this.$refs.seckillTime.clientWidth;
			let _i = document.querySelector('.seckill-time-ul').style.left.indexOf('px')
			let _li = document.querySelector('.seckill-time-ul').style.left.substring(0, _i)
			
		    if (this.timeList.length < 7) return
		    let page = this.timeList.length % 7 // ปริมาณที่มองเห็นได้7ชิ้น
		    let position = 150
			if(page == 0) page = this.timeList.length - 7 // ปริมาณที่มองเห็นได้7ชิ้น
		    else if (page != 0 && page != 1 && page < 2) return
			
		    if (tag == "prev") {
		        if (this.thumbPosition != 0 && Math.round(this.thumbPosition, 2) != position && position < Math.abs(this.thumbPosition)) {
		            this.thumbPosition += position
		        } else {
					this.thumbPosition = 0
		        }
		    } else if (tag == "next") {
				
		        if (Math.round(this.thumbPosition, 2) != -Math.round(position * page, 2)) {
					
					let _ul = this.timeList.length * position
					let _left = _ul - _div
					if (Math.abs(this.thumbPosition) - _left >= 0) {
						this.thumbPosition = -_left
					} else if (Math.abs(this.thumbPosition) - _left < -150) {
						this.thumbPosition -= position
					} else {
						this.thumbPosition = -_left
					}
		        } else {
		        }
		    }
		},
		countDownS_cb() {},
		countDownE_cb() {
			this.seckillText = 'กิจกรรมได้สิ้นสุดลงแล้ว';
		},
		getAdList() {
			adList({ keyword: 'NS_PC_SECKILL' })
				.then(res => {
					this.adList = res.data.adv_list;
					for (let i = 0; i < this.adList.length; i++) {
						if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url);
					}
					this.loadingAd = false;
				})
				.catch(err => {
					this.loadingAd = false;
				});
		},
		/**
		 * ระยะเวลาการขายสายฟ้าแลบ
		 */
		getTimeList() {
			timeList()
				.then(res => {
					let data = res.data;
					if (!data) return;
					let time = new Date(res.timestamp * 1000);
					let newTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds();
					data.list.forEach((v, k) => {
						if (v.seckill_start_time <= newTimes && newTimes < v.seckill_end_time) {
							v.isNow = true;
							if(this.shouType == true){
								this.seckillId = v.id;
								this.seckillName = v.name;
								this.index = k;
								this.seckillIndex = k;
								
								let endTime = parseInt(time.getTime() / 1000) + (v.seckill_end_time - newTimes);
								this.seckillTimeMachine = {
									currentTime: res.timestamp,
									startTime: res.timestamp,
									endTime: endTime
								};
							}
						} else {
							v.isNow = false;
						}
					});

					this.timeList = data.list;
					if (!this.seckillId) {
						for (let i = 0; i < data.list.length; i++) {
							if (newTimes < data.list[i].seckill_start_time && i == 0) {
								this.seckillId = data.list[i].id;
								this.index = i;
								this.seckillIndex = i;
							} else if (newTimes < data.list[i].seckill_start_time && newTimes > data.list[i - 1].seckill_end_time && i != 0) {
								this.seckillId = data.list[i].id;
								this.index = i;
								this.seckillIndex = i;
							} else if (i == data.list.length - 1 && newTimes > data.list[i].seckill_end_time) {
								this.seckillId = data.list[i].id;
								this.index = i;
								this.seckillIndex = i;
							}
						}
					}

					// this.$nextTick(function() {
					// 	if (this.timeList.length > 0) {
					// 		let _div = this.$refs.seckillTime.clientWidth;
					// 		let _li = document.querySelector('.seckill-time-li').clientWidth
					// 		let leftWidth = this.index * _li; // ช่วงเวลาในสแน็ปอินคือตําแหน่งทางด้านซ้าย
					// 		let offsetWidth = leftWidth - (_li) * 4; // ระยะทางที่ต้องการออฟเซ็ตซ้าย
					// 		this.thumbPosition = -offsetWidth
					// 	}
					// });
				})
				.catch(err => {
					this.$notify.error({title: 'Error',message: err.message});
				});
		},
		/**
		 * สินค้าสายฟ้าแลบ
		 */
		getGoodsList() {
			goodsPage({
				page_size: this.pageSize,
				page: this.currentPage,
				seckill_time_id: this.seckillId,
				site_id: this.siteId
			})
				.then(res => {
					console.log(res,'สินค้าสายฟ้าแลบ')
					this.goodsList = res.data.list;
					this.goodsList.forEach(v => {
						v.goods_image = v.goods_image.split(',')[0]
					})
					this.total = res.data.count;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
					this.$notify.error({title: 'Error',message: err.message});
				});
		},
		/**
		 * รายละเอียดสินค้า
		 */
		toGoodsDetail(id, key) {
			let time = new Date();
			let newTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds();
			if (this.timeList[this.key].seckill_start_time <= newTimes && newTimes < this.timeList[this.key].seckill_end_time) {
				this.timeList[this.key].isNow = true;
			} else {
				this.timeList[this.key].isNow = false;
			}
			if (!this.timeList[this.key].isNow) {
				this.$message.error('ยังไม่ถึงเวลาคอยติดตาม！')
				return;
			}
			this.$router.push('/promotion/seckill-' + id);
		},
		handlePageSizeChange(size) {
			this.pageSize = size;
			this.refresh();
		},
		handleCurrentPageChange(page) {
			this.currentPage = page;
			this.refresh();
		},
		refresh() {
			this.loading = true;
			this.getGoodsList();
		},
		/**
		 * โหลดรูปภาพไม่สําเร็จ
		 */
		imageError(index) {
			this.goodsList[index].goods_image = this.defaultGoodsImage;
		}
	}
};